import { fetchConfig } from "./fetch";
import { getStorgeProvider } from "./storage";
export const EXPIRY_DAYS = 7;
export const PERSISTED_KEY = "ca-launchdarkly-client-id";
export const FAKE_CLIENT_ID = "UNAVAILABLE";
/**
 * Calculates number of days between two dates
 *
 * @param a Time value in milliseconds
 * @param b Time value in milliseconds
 * @returns Number of days
 */
function calcNumberOfDaysBetween(a, b) {
    const days = (a - b) / (1000 * 3600 * 24);
    return isNaN(days) ? 0 : days;
}
/**
 * Check whether text has a valid client-side format or not
 *
 * @param identifier A client-side ID
 * @returns True if ID is valid or false otherwise
 */
function isValidClientId(identifier) {
    return /^[a-zA-Z0-9-]+$/.test(identifier);
}
/**
 * Adds day(s) to a time value
 *
 * @param days Number of days
 * @param time Time value in milliseconds
 * @returns Time value in milliseconds with added number of days
 */
function addDays(days, time = Date.now()) {
    const date = new Date(time);
    date.setDate(date.getDate() + days);
    return date.getTime();
}
/**
 * Retrieves client-side ID from storage
 *
 * @returns A client-side ID
 */
export function getFromStorage() {
    const today = Date.now();
    try {
        const { id = "", expiry = today } = JSON.parse(getStorgeProvider()?.get(PERSISTED_KEY) ?? "");
        if (isValidClientId(id) && calcNumberOfDaysBetween(expiry, today) > 0) {
            return id;
        }
    }
    catch (error) { }
    return null;
}
/**
 * Fetches client-side ID from server
 *
 * @returns A client-side ID
 */
export async function fetchFromServer() {
    const response = await fetchConfig("/sgwu/launchdarkly-config");
    if (!response.ok) {
        throw new Error("Unable to retrieve client-side ID due to a server error");
    }
    const { configuration } = (await response.json());
    const id = configuration?.clientID;
    if (id === undefined) {
        throw new Error("Unable to retrieve client-side ID due to an invalid server response");
    }
    try {
        getStorgeProvider()?.set(PERSISTED_KEY, JSON.stringify({
            id,
            expiry: addDays(EXPIRY_DAYS),
        }));
    }
    catch (error) { }
    return id;
}
/**
 * Retrieves a client-side ID for auto-configuration purposes or fails otherwise
 *
 * @returns A promise which resolves a client-side ID or a fake ID otherwise
 */
export const getClientSideID = async () => {
    return getFromStorage() ?? (await fetchFromServer());
};
